export const formatPriceWithSpaces = (value: string): string => {
    const numberValue = value.replace(/\D/g, ""); // Убираем все символы, кроме цифр
    return numberValue.replace(/\B(?=(\d{3})+(?!\d))/g, " "); // Добавляем пробелы
};